export const DEFAULT_TENANT: string = 'Tangoe';
export const STORE_NAME: string = 'Store';
export const DEFAULT_LOGO_URL: string = './assets/images/tangoe_logo.png';

export const DEFAULT_LAYOUT_STATE: LayoutState = {
  display_header: true,
  display_page_title: false,
  can_navigate_to_dashboard: false,
  logo_url: DEFAULT_LOGO_URL,
  tenant_name: DEFAULT_TENANT
};

export const DEFAULT_PAGE_TITLE_STATE: PageTitleState = {
  navigation_title: '',
  page_title: '',
  bg: false,
  sticky: false
};

export interface LayoutState {
  display_header: boolean;
  display_page_title: boolean;
  can_navigate_to_dashboard: boolean;
  logo_url: string;
  tenant_name: string;
}

export interface PageTitleState {
  navigation_title: string;
  page_title: string;
  bg: boolean;
  sticky: boolean;
}
